import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { StatusShape } from '../layer-status-design-picker/layer-status-design-picker.component';


@Component({
    selector: 'ins-layer-status-preview',
    templateUrl: './layer-status-preview.component.html',
    styleUrls: ['./layer-status-preview.component.scss'],
    imports: []
})
export class LayerStatusPreviewComponent implements OnChanges {
  @Input() bgColor: string = '000000';
  @Input() shape: StatusShape = StatusShape.Circle;
  @Input() label: string = '';

  @Output() placemarkClicked = new EventEmitter<void>();
  public StatusShape = StatusShape;
  public textColor: string = 'black';

  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.bgColor?.currentValue) {
      this.textColor = this.isDark(this.bgColor) ? 'white' : 'black';
      this.bgColor = `#${this.bgColor ? this.bgColor : '#FFFFFF'}`;
    }
    if (changes.shape?.currentValue) {
      this.shape = this.shape ? this.shape : StatusShape.Circle;
    }
  }

  public onPlacemarkClick(): void {
    this.placemarkClicked.emit();
  }

  private isDark(hexColor) {
    if (hexColor.startsWith('#')) {
      hexColor = hexColor.slice(1);
    }
    const r = parseInt(hexColor.substring(0, 2), 16);
    const g = parseInt(hexColor.substring(2, 4), 16);
    const b = parseInt(hexColor.substring(4, 6), 16);
    const luminance = (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255;
    const threshold = 0.8;
    return luminance < threshold;
  }

}
